import { render, staticRenderFns } from "./SkupinaProfilSelect.vue?vue&type=template&id=53ab97fb&"
import script from "./SkupinaProfilSelect.vue?vue&type=script&lang=ts&"
export * from "./SkupinaProfilSelect.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports